import TaskIcon from '@plato/ui-legacy/assets/icons/task-icon';
import { DropdownMenuItem } from '@plato/ui-legacy/components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';
import type { CrmTaskDTO } from '../../../server/dto/crm-task-dto.ts';
import type { TaskCreatedSource } from '../../analytics/types/analytics-events.ts';
import { useShowCreateTaskDialog } from '../hooks/use-show-create-task-dialog.ts';

export type TaskLinks = Pick<CrmTaskDTO['links'][0], 'modelId' | 'modelType' | 'title'>[];

type DropdownMenuItemCreateTaskProps = {
    links: TaskLinks;
    source: TaskCreatedSource;
};

export function DropdownMenuItemCreateTask({ links, source }: DropdownMenuItemCreateTaskProps) {
    const { t } = useTranslation();
    const showCreateTaskDialog = useShowCreateTaskDialog();

    return (
        <DropdownMenuItem
            onSelect={() => {
                showCreateTaskDialog({ links, source });
            }}
        >
            <TaskIcon className="h-4 w-4" />
            <span>{t('customer_detail__header__task', { ns: 'customer-detail' })}</span>
        </DropdownMenuItem>
    );
}
